<template>
  <li class="content__list__item-row">
    <div
      class="content__result__link col-12 d-flex align-items-center justify-content-between full-width"
    >
      <div class="d-flex align-items-center" style="max-width: 90%">
        <el-checkbox
          v-if="hasCheckbox"
          v-model="checked"
          class="mb-0 mr-2 d-flex checkbox"
        />

        <div
          class="d-flex align-items-center col pl-0"
          @click="$emit('focus-content', content)"
        >
          <img :src="imgSrc" class="content-icon mr-2" />
          <div
            class="content-label-span d-flex align-items-center"
            :class="[labelClass]"
          >
            {{ content.label }}
          </div>
          <slot name="label-tag" v-bind:label-tag="content"></slot>
        </div>
      </div>
      <div class="content-label d-flex justify-content-end">
        <CommonNodeStatus
          :content="content"
          @update-content="updateContent"
          @update-content-verification="updateContentVerification"
          v-if="itemType !== 'archive'"
          class="d-flex flex-row align-items-center mr-3"
        />
        <ContentListItemLabel
          v-for="label in content.labels"
          :key="label.id"
          :label="label"
        />
        <ContentViewSettingModal
          v-if="displayContentViewParametersModal"
          :open="displayContentViewParametersModal"
          :content="content"
          :contentTitle="content.label"
          @update-content-view-setting="updateContentSettings"
          @close="displayContentViewParametersModal = false"
        />
        <DangerDeleteModal
          v-if="displayDeleteModal"
          :display="displayDeleteModal"
          type="archive"
          to-delete-name="SELECTED-CONTENTS"
          @choice="bulkDelete"
          @close="displayDeleteModal = false"
        />
        <base-dropdown
          class="nav-item"
          position="right"
          v-if="itemType !== 'archive'"
        >
          <font-awesome-icon
            slot="title"
            :icon="['fas', 'ellipsis-h']"
            class="options-selection mr-2"
            role="button"
            data-toggle="dropdown"
            aria-haspopup="true"
            aria-expanded="false"
          />
          <span v-if="itemType === 'content'">
            <a class="dropdown-item cursor" @click="archive">{{
              $t('knowledge.search.content.archive')
            }}</a>
            <div class="dropdown-divider"></div>
            <a
              class="dropdown-item cursor"
              @click="openContentViewParametersModal"
              >{{ $t('knowledge.search.content.edit') }}</a
            >
          </span>
        </base-dropdown>
      </div>
    </div>
  </li>
</template>

<script>
import ContentListItemLabel from '@/components/ListItems/ContentListItemLabel';
import CommonNodeStatus from '@/views/KnowledgeEditor/NavigationBar/Navigator/NavigatorNode/CommonNode/CommonNodeStatus';
import ContentViewSettingModal from '@/components/Modals/ContentViewSettingModal/ContentViewSettingModal';
import DangerDeleteModal from '@/components/Modals/DangerDeleteModal';

const diagIcon = require('assets/diag-icon-v2.svg');
const articleIcon = require('assets/article-icon-v2.svg');
const folderIcon = require('assets/open-folder.svg');

export default {
  name: 'content-list-item',
  components: {
    ContentListItemLabel,
    CommonNodeStatus,
    ContentViewSettingModal,
    DangerDeleteModal,
  },
  props: {
    content: Object,
    selectedContents: Array,
    itemType: String,
    labelClass: {
      type: String,
      default: 'test-label-class',
    },
    hasCheckbox: {
      type: Boolean,
      default: true,
    },
  },
  computed: {
    checked: {
      get() {
        return this.selectedContents.includes(this.content.id);
      },
      set(val) {
        let selectedContents = [...this.selectedContents];
        if (val) {
          selectedContents.push(this.content.id);
        } else {
          selectedContents = this.selectedContents.filter(
            (sc) => sc !== this.content.id,
          );
        }
        this.$emit('update-selected-contents', selectedContents);
      },
    },
    imgSrc() {
      switch (this.content.type) {
        case 'Article':
          return articleIcon;
        case 'Case':
          return folderIcon;
        default:
          return diagIcon;
      }
    },
  },
  data() {
    return {
      displayContentViewParametersModal: false,
      displayDeleteModal: false,
    };
  },
  methods: {
    updateContent(event) {
      this.$emit('update-content', {
        contentIds: [this.content.id],
        key: Object.keys(event)[0],
        value: event[Object.keys(event)[0]],
      });
    },
    updateContentVerification(isOutdated) {
      this.$emit('update-content-verification', {
        id: this.content.id,
        isOutdated,
      });
    },
    updateContentSettings(evt) {
      this.$emit('update-content-settings', evt);
    },
    archive() {
      this.$emit('archive', [this.content.id]);
    },
    openContentViewParametersModal() {
      this.displayContentViewParametersModal = true;
    },
    bulkDelete(e) {
      if (e) this.$emit('delete', [this.content.id]);
      this.displayDeleteModal = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.content-label-span {
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.content__list__item-row {
  list-style: none;
  margin: 0px 0px;
  padding: 4px 0px;
  &:hover {
    background-color: $grey-1-mayday;
    border-radius: 2px;
    cursor: pointer;
    & .content-icon {
      color: $blue-mayday;
    }
  }
}

.content-icon {
  max-width: 16px;
  max-height: 16px;
}

.content-label-icon {
  color: $red-mayday;
  border: 1px solid $red-mayday;
  background-color: rgba($red-mayday, 0.1);
  border-radius: 2px;
  padding: 2px;
}
.options-selection {
  color: $grey-5-mayday;
  max-width: 12px;
  visibility: hidden;
  &:hover {
    color: $blue-mayday;
  }
}

.content__list__item-row {
  &:hover {
    .options-selection {
      visibility: visible;
    }
    .checkbox {
      :deep() .el-checkbox__input {
        visibility: visible;
      }
    }
  }
}

.checkbox {
  margin-left: -24px;
  :deep() .el-checkbox__input {
    visibility: hidden;
    margin: auto;
    width: 14px;
    height: 14px;
  }
  :deep() .is-checked {
    visibility: visible;
  }
  :deep() .el-checkbox__inner {
    height: 14px;
    width: 14px;
  }
}

.hidden-checkbox {
  visibility: hidden;
}

.dropdown-item {
  font-size: 12px !important;
  &:hover {
    color: $blue-mayday !important;
  }
}

.dropdown-item-danger {
  color: $red-mayday;
  background-color: rgba($yellow-mayday, 0.1);
}
</style>
